module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/setting-list/setting-list.component.scss
// module id = 1535
// module chunks = 0